import { combineReducers } from "redux";
import { getAmpStatusReducer } from "./ampStatusReducer";
import { updateAmpStatusReducer } from "./updateAmpStatusReducer";


const ampStatusReducer = combineReducers({
    ampStatus: getAmpStatusReducer,
    updateAmpStatus: updateAmpStatusReducer
});

export default ampStatusReducer;